<script setup>
  import { reactive, ref } from 'vue';

  import { authService } from '@/services/auth-service.js';

  const form = reactive({
    email: '',
  })


const loading = ref(false)
const error = ref(null)
const success = ref(null)

const resetPasswordRequest = async () => {
  try {
    loading.value = true
    error.value = null


    const  result = await authService.reset_pass_request(form.email);
    if(result && result.data && result.data.status){
      success.value = result.data.message || "Success";
      setTimeout(() => {
        window.location.href = '/login'
      }, 1500);
    }else{
      error.value = 'Request error'
    }

  } catch (e) {
    error.value = e.response?.data?.message || 'Request error'
  } finally {
    loading.value = false
  }
}


</script>

<template>
    <div class="page">
      <div class="wrapper">


        <div class="card-form">

          <div class="logo">
            <div class="my-4" id="logo-image"></div>
          </div>
          <div v-if="error" class="alert alert-error">
            {{ error }}
          </div>

          <div v-if="success" class="alert alert-success">
            {{ success }}
          </div>

          <form @submit.prevent="resetPasswordRequest" class="p-4">
          <div class="input-group">
            <input type="text" v-model="form.email" placeholder="Email">
          </div>


          <button class="btn-button" :disabled="loading">
            {{ loading ? 'Loading...' : 'Send request' }}
          </button>
          </form>

        </div>

        <div class="footer">
          Impact Journals, LLC
        </div>

      </div>
    </div>

</template>

